<div class="offer" *ngIf="openedDocument$ | async as openedDocument" >
    <div class="summary-title">
        <div class="summary-title__content">
            <ng-container *ngIf="+openedDocument.documentTypeId === documentTypes.complaint">
                {{ 'COMPLAINT|Obsługa zgłoszenia reklamacyjnego' | translate }}
            </ng-container>
            <ng-container *ngIf="+openedDocument.documentTypeId === documentTypes.service">
                {{ 'COMPLAINT|Obsługa zgłoszenia serwisowego' | translate }}
            </ng-container>
            <span> {{ openedDocument.documentNumber.join('') }}</span>
        </div>
        <div class="summary-title__actions">
            <button
                [disabled]="!hasAccessTo.manageComplaint || synced !== 'synced'"
                iccButton
                appearance="outline"
                (click)="editComplaint(openedDocument)"
            >
                {{ 'COMPLAINT|Edytuj status i dane' | translate }} <icc-icon name="edit"></icc-icon>
            </button>
        </div>
    </div>

    <icc-complaint-summary
        [document]="openedDocument"
        [positionsWorkflowsGroups]="positionsWorkflowsGroups"
        [positions]="positions$ | async"
        [selectedPositions]="selectedPositions"
        [appointments]="appointments$ | async"
        [appointmentsAttachments]="appointmentAttachments$ | async"
        (complaintTypeChange)="changeComplaintType($event)"
        (clearSelectedPositions)="clearSelectedPositions()"
    ></icc-complaint-summary>

    <div class="complaint-navbar-wrapper">
        <div class="complaint-navbar">
            <div class="complaint-navbar__item">
                <button iccIconButton appearance="flat-base" (click)="scrollToTop()">
                    <icc-icon name="navigate_top"></icc-icon>
                </button>
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('details')">
                {{ 'COMPLAINT|Szczegóły zgłoszenia' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('appointments')">
                {{ 'COMPLAINT|Planowanie wizyt' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('spare-parts')">
                {{ 'COMPLAINT|Użyte produkty' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('tree')">
                {{ 'COMPLAINT|Drzewo obsługujących' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('history')">
                {{ 'COMPLAINT|Historia zgłoszenia' | translate }}
            </div>
        </div>
    </div>

    <div class="section-header" id="details">
        <div class="section-header__title">
            {{ 'COMPLAINT|Szczegóły zgłoszenia' | translate }}
        </div>
    </div>

    <div class="product-elements" *ngIf="positions$ | async as positions" >
        <div class="positions-container">
            <ng-container *ngFor="let position of positions; index as id; trackBy: trackByPosition">
                <icc-complaint-position
                    *ngIf="position !== null && openedDocuments[position.documentId]"
                    [position]="position"
                    [showDetails]="positionsShowDetails.get(position.uuid)"
                    [positionTitle]="positionsTitles.get(position.uuid)"
                    [positionsCount]="positions.length"
                    [selectedPositionsCount]="selectedPositions.length"
                    [document]="openedDocuments[position.documentId]"
                    [attachments]="(attachments$ | async)?.get(position.uuid) || []"
                    (showDetailsEvent)="switchShowDetails(position.uuid, $event)"
                    (selectPosition)="selectPosition($event)"
                    (unselectPosition)="unselectPosition($event)"
                    [id]="position.uuid"
                    [index]="id"
                ></icc-complaint-position>
            </ng-container>
        </div>
    </div>

    <div class="section-header borderless" id="appointments">
        <div class="section-header__title">
            {{ 'COMPLAINT_APPOINTMENT|Planowanie wizyt' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.scheduleAppointment && ((openedDocument.assignedTo && openedDocument.assignedTo.startsWith(getUserType())) || hasAccessTo.manageComplaintManufacturer)" class="appointments-button" iccButton appearance="outline" (click)="editAppointment(openedDocument)">
                {{ 'COMPLAINT_APPOINTMENT|Zaplanuj wizytę' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
        </div>
    </div>

    <div class="product-elements" *ngIf="complaintAppointments?.length">
        <div class="appointments-container">
            <ng-container *ngFor="let appointment of complaintAppointments; index as id; trackBy: trackByAppointment">
                <icc-complaint-appointment
                    *ngIf="appointment !== null && openedDocuments[appointment.documentId]"
                    [appointment]="appointment"
                    [document]="openedDocuments[appointment.documentId]"
                    [attachments]="(appointmentAttachments$ | async)?.get(appointment.uuid) || []"
                    [id]="appointment.uuid"
                    [index]="id"
                    [positionsWorkflowsGroups]="positionsWorkflowsGroups"
                    class="appointments-container__item"
                ></icc-complaint-appointment>
            </ng-container>
        </div>
    </div>

    <div class="section-header" [class.borderless]="hasAccessTo.manageComplaint && openedDocument.assignedTo !== 'manufacturer' && openedDocument.distributorCompanyId === activeUserCompanyId && !getStatus(openedDocument.statusId)?.closed && openedDocument.assignedTo && openedDocument.assignedTo.startsWith(getUserType())" id="spare-parts">
        <div class="section-header__title">
            {{ 'COMPLAINT_APPOINTMENT|Użyte produkty' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.manageComplaint && openedDocument.assignedTo !== 'manufacturer' && openedDocument.distributorCompanyId === activeUserCompanyId && !getStatus(openedDocument.statusId)?.closed && openedDocument.assignedTo && openedDocument.assignedTo.startsWith(getUserType())" class="appointments-button" iccButton appearance="outline" (click)="manageComplaintSpareParts(openedDocument)">
                {{ 'COMPLAINT_SPARE_PART|Użyto produkty' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
        </div>
    </div>

    <div *ngIf="productsList" class="complaint-spare-parts__container">
        <div class="complaint-spare-parts" *ngFor="let complaintSparePart of complaintSpareParts; index as i">
            <div class="complaint-spare-parts-card" *ngIf="!complaintSparePart.isDeleted">
                <div class="complaint-spare-parts-card__body">
                    <div class="complaint-spare-parts-card__details">
                        <span class="complaint-spare-parts-card__identifier">
                            <icc-icon name="date"></icc-icon>
                        </span>
                        <div class="complaint-spare-parts-card__details-info">
                            <div class="complaint-spare-parts-card__details-row__header">
                                <span class="complaint-spare-parts-card__company" [ngClass]="activeUserCompanyId === complaintSparePart.companyId ? 'fw-600' : ''">
                                    <span *ngIf="complaintSparePart.companyId === openedDocument.authorizedRetailer?.companyId">
                                        {{ openedDocument.authorizedRetailer?.companyName }}
                                    </span>
                                    <span *ngIf="complaintSparePart.companyId === openedDocument.distributor?.companyId">
                                        {{ openedDocument.distributor?.companyName }}
                                    </span>
                                    <span *ngIf="complaintSparePart.companyId === openedDocument.manufacturer?.companyId">
                                        {{ openedDocument.manufacturer?.companyName }}
                                    </span>
                                </span>
                            </div>

                            <div class="complaint-spare-parts-card__details-row">
                                <span class="complaint-spare-parts-card__date-used">
                                    {{ complaintSparePart.created | date: 'shortDate'}}
                                </span>

                                <span class="complaint-spare-parts-card__product-name" style="font-weight: 700;">
                                    {{ getProductName(complaintSparePart.productId) }}
                                </span>

                                <span class="complaint-spare-parts-card__quantity fw-700">
                                    {{ 'COMPLAINT_SPARE_PART|Ilość:' | translate }} {{ complaintSparePart.quantity }} {{ (getUnit(complaintSparePart.productId) | unit:complaintSparePart.quantity:true) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="complaint-spare-parts-card__actions" *ngIf="activeUserCompanyId === complaintSparePart.companyId && hasAccessTo.manageComplaint && openedDocument.assignedTo !== 'manufacturer' && !getStatus(openedDocument.statusId)?.closed">
                        <button
                            iccButton
                            (click)="removeSparePartFromComplaint(complaintSparePart)"
                            [title]="'INTERFACE|Usuń' | translate"
                            appearance="outline"
                        >
                            <icc-icon name="delete"></icc-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-header" id="tree">
        <div class="section-header__title">
            {{ 'COMPLAINT|Drzewo obsługujących' | translate }}
        </div>
    </div>

    <div class="parties" [class.preview]="preview">
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Reklamujący:' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.clientName">{{ openedDocument.clientName }}<br></span>
                            <span class="parties-card_data__content-box__company_name" *ngIf="!openedDocument?.clientName && authorizedRetailerDistributorComplaint">{{ 'COMPLAINT|APS' | translate }}<br></span>
                            <span class="parties-card_data__content-box__company_name" *ngIf="!openedDocument?.clientName && distributorManufacturerComplaint">{{ 'COMPLAINT|Dystrybutor' | translate }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" iccIconButton [small]="true" appearance="flat" (click)="openUserPreviewDialog('client', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>
                        <div class="parties-card_data__content-box__row">
                            <b class="parties-card_data__content-box__name" *ngIf="openedDocument?.clientName">{{ openedDocument.clientName }}<br></b>
                            <span *ngIf="openedDocument?.clientPhoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument.clientPhoneNumber }}<br></span>
                            {{ openedDocument.clientEmail }}<br>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Sprzedający (APS):' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box" [class.currently-assigned]="openedDocument.assignedTo === 'authorizedRetailer'">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.authorizedRetailer?.companyName">{{ openedDocument.authorizedRetailer?.companyName }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview && canChangeUser('authorizedRetailer') && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" iccIconButton [small]="true" appearance="flat" (click)="openChangeUserDialog('authorizedRetailer', openedDocument)" [title]="'INTERFACE|Zmień' | translate"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                                <button *ngIf="!preview && !distributorManufacturerComplaint" iccIconButton [small]="true" appearance="flat" (click)="openUserPreviewDialog('authorizedRetailer', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="parties-card_data__content-box__row">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null && openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.companyName === ''">{{ openedDocument.authorizedRetailer?.referenceName }}<br></span>
                            <div class="parties-card_data__content-box__responsible_user">
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null">{{ 'COMPLAINT|Punkt sprzedaży - NIP:' | translate }} </span>
                                <span class="parties-card_data__content-box__name" *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId !== null && openedDocument?.authorizedRetailer?.companyId !== null">{{ openedDocument.authorizedRetailer?.referenceName }}<br></span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null">{{ openedDocument.authorizedRetailer?.companyVatNr }}<br></span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null"> {{ 'COMPLAINT|Punkt sprzedaży - adres:' | translate }} </span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null">{{ openedDocument.authorizedRetailer?.address }}<br></span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument.authorizedRetailer?.phoneNumber }}<br></span>
                                {{ openedDocument.authorizedRetailer?.email }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Dystrybutor:' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box" [class.currently-assigned]="openedDocument.assignedTo === 'distributor'">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.distributor?.companyName">{{ openedDocument.distributor?.companyName }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview && canChangeUser('distributor') && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" [small]="true" iccIconButton appearance="flat" (click)="openChangeUserDialog('distributor', openedDocument)" [title]="'INTERFACE|Zmień' | translate"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                                <button *ngIf="!preview" [small]="true" iccIconButton appearance="flat" (click)="openUserPreviewDialog('distributor', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="parties-card_data__content-box__row">
                            <div class="parties-card_data__content-box__responsible_user">
                                <span class="parties-card_data__content-box__name" *ngIf="openedDocument?.distributor?.referenceName">{{ openedDocument.distributor?.referenceName }}<br></span>
                                <span *ngIf="openedDocument?.distributor?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument?.distributor?.phoneNumber }}<br></span>
                                {{ openedDocument?.distributor?.email }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Producent:' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box" [class.currently-assigned]="openedDocument.assignedTo === 'manufacturer'">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.manufacturer?.companyName">{{ openedDocument.manufacturer?.companyName }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview" [small]="true" iccIconButton appearance="flat" (click)="openUserPreviewDialog('manufacturer', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="parties-card_data__content-box__row">
                            <div class="parties-card_data__content-box__responsible_user">
                                <span class="parties-card_data__content-box__name" *ngIf="openedDocument?.manufacturer?.referenceName">{{ openedDocument.manufacturer?.referenceName }}<br></span>
                                <span *ngIf="openedDocument?.manufacturer?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument.manufacturer?.phoneNumber }}<br></span>
                                {{ openedDocument.manufacturer?.email }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="section-header" [class.borderless]="hasAccessTo.addComplaintNote" id="history">
        <div class="section-header__title">
            {{ 'COMPLAINT|Historia zgłoszenia' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.addComplaintNote" class="details-card-body-button-note" iccButton appearance="outline" (click)="createComplaintNote(openedDocument)">
                {{ 'COMPLAINT|Dodaj notatkę' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
        </div>
    </div>

    <div class="history">
        <ng-container *ngIf="changesLoading">
            <div class="details-card">
                <div class="details-card-header"></div>
                <div class="details-card-body">
                    <div class="details-card-body-description">
                        {{ 'INTERFACE|Trwa ładowanie danych...' | translate }}
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!changesLoading">
            <ng-container *ngFor="let change of changes; trackBy: trackByFunction">
                <div class="details-card" [ngClass]="{'note-entry': change.type === 'addComplaintNote'}">
                    <div class="details-card__body">
                        <div class="details-card__details">
                            <div class="details-card__icon">
                                <icc-icon name="date"></icc-icon>
                            </div>
                            <div class="details-card__details-info">
                                <div class="details-card__details-row__header">
                                    <span *ngIf="change?.company?.length && change.author !== 'Klient'" class="details-card__company">{{ change.company }}</span>
                                    <span *ngIf="change?.company?.length && change.author === 'Klient'" class="details-card__company">{{ openedDocument.clientName }}</span>

                                    <span *ngIf="change.type === 'addComplaintNote' && change.value?.visibility" class="note-visibility">
                                        <icc-complaint-note-visibility [visibility]="change.value.visibility"></icc-complaint-note-visibility>
                                    </span>
                                </div>

                                <div class="details-card__details-row additional-spacing">
                                    <span class="details-card__change-time">
                                        {{ change.date | date: 'short' }},
                                    </span>
                                    <span class="details-card__change-author">
                                        {{ change.author.length ? change.author : '' }}
                                    </span>
                                </div>

                                <div class="details-card__details-row">
                                    <div class="details-card-body-description">

                                        <ng-container *ngIf="change.type === 'addComplaintNote'">
                                            <div class="note-container">
                                                <div *ngIf="change.title" class="note-title">
                                                    {{ change.title }}
                                                </div>
                                                <div class="note-description">
                                                    {{ change.description }}
                                                </div>
                                                <div *ngIf="change.value.replyId" class="note-quotation">
                                                    <div class="note-quotation__info">
                                                        {{ change.subtitle }}
                                                    </div>
                                                    <div class="note-quotation__content">
                                                        {{ change.quotedContent }}
                                                    </div>
                                                </div>
                                                <div class="note-attachments">
                                                    <div class="note-attachments-body" *ngFor="let attachment of (complaintNoteAttachments$ | async)?.get(change.value.uuid) || []">
                                                        <div class="image-container">
                                                            <a
                                                                *ngIf="attachment"
                                                                [href]="'/complaint_attachments/' + attachment.uuid"
                                                                target="_blank"
                                                            >
                                                                <img
                                                                    [src]="'/complaint_attachments/' + attachment.uuid"
                                                                    [alt]="attachment.name"
                                                                >
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="!change?.group?.length && change.type !== 'addComplaintNote'">
                                            <icc-icon name="done"></icc-icon>
                                            {{ change.title }}
                                            <span *ngIf="change?.html" [innerHTML]="change.description"></span>
                                            <ng-container *ngIf="!change?.html">
                                                {{ change.description ? ': ' + change.description : ((change.type === 'setField' || change.type === 'setPositionField') ? ': ' + ('COMPLAINT|Brak' | translate) : '' )}}
                                            </ng-container>
                                            <button *ngIf="change.type === 'addDoc'" class="details-card-body-button" iccButton appearance="outline" (click)="showDocumentFirstVersion(change)">
                                                {{ 'COMPLAINT|Pokaż pierwotną wersję' | translate }}
                                            </button>
                                            <button *ngIf="change.type === 'addAppointment'" class="details-card-body-button" iccButton appearance="outline" (click)="showAppointmentFirstVersion(change)">
                                                {{ 'COMPLAINT_APPOINTMENT|Pokaż pierwotną wersję wizyty' | translate }}
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="change?.group?.length">
                                            <icc-icon name="done"></icc-icon>
                                            <ng-container *ngFor="let row of change.group">
                                                {{ row.title }}
                                                <span *ngIf="row?.html" [innerHTML]="row.description"></span>
                                                <ng-container *ngIf="!row?.html">
                                                    {{ row.description ? ': ' + row.description : ((change.type === 'setField' || change.type === 'setPositionField') ? ': ' + ('COMPLAINT|Brak' | translate) : '' )}}<br>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-card__actions">
                            <button
                                iccIconButton
                                (click)="replyToComplaintNote(openedDocument, change.value)"
                                [title]="'COMPLAINT|Odpowiedz' | translate"
                                appearance="flat"
                                *ngIf="change.type === 'addComplaintNote'"
                            >
                                <icc-icon name="comment_quote"></icc-icon>
                            </button>
                        </div>

                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>

</div>
